import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-sub-tab-table',
  templateUrl: './sub-tab-table.component.html',
  styleUrls: ['./sub-tab-table.component.css']
})
export class SubTabTableComponent implements OnInit {
  @Input('formCtrl') formArray: FormArray;

  ngOnInit(): void {
    console.log('SubTabs:', this.formArray);
  }

  removeRow(index: number) {
    this.formArray.removeAt(index);
  }

  addRow() {
    const newGroup = new FormGroup({
      name: new FormControl(''),
      localizationKey: new FormControl(''),
      order: new FormControl(this.formArray.length + 1), // 自动设置顺序
      url: new FormControl(''),
      queryParams: new FormControl('')
    });
    this.formArray.push(newGroup);
  }

  private updateOrder() {
    this.formArray.controls.forEach((group, index) => {
      (group as FormGroup).get('order')?.setValue(index + 1);
    });
  }

  moveUp(index: number) {
    if (index > 0) {
      const current = this.formArray.at(index);
      const prev = this.formArray.at(index - 1);
      this.formArray.setControl(index - 1, current);
      this.formArray.setControl(index, prev);
      this.updateOrder(); // 更新顺序
    }
  }

  moveDown(index: number) {
    if (index < this.formArray.length - 1) {
      const current = this.formArray.at(index);
      const next = this.formArray.at(index + 1);
      this.formArray.setControl(index + 1, current);
      this.formArray.setControl(index, next);
      this.updateOrder(); // 更新顺序
    }
  }
}
